import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataHelper } from '@app/helpers/data.helper';
import { DataService } from '@app/services/data.service';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'boost-info-modal',
  templateUrl: '../sharedTemplates/boost-info-modal.html',
})
export class BoostInfoModal {
  constructor(
    public _DataHelper: DataHelper,
    public dialogRef: MatDialogRef<BoostInfoModal>,
    private _DataService: DataService,
    private router: Router,
    private _UiHelper: UiHelper,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this._UiHelper.closeAllMenus();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  setBoostCheckBox() {
    this._DataHelper.boostBonusCheckBox = true;
    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataService.fireApiCall('refreshCurrentSlip');
    this.dialogRef.close();
  }
  openInNewTab(url: string): void {
    window.open(this.router.serializeUrl(this.router.createUrlTree([url])), '_blank');
  }
}
